<template>
  <tr
    class="clickable-row"
    :class="{ deleting: deleting }"
    @click="handleRowClick"
  >
    <td v-if="!details" :class="{ deleting: deleting }">
      {{ audience.firstName }}
    </td>
    <td v-if="!details" :class="{ deleting: deleting }">
      {{ audience.lastName }}
    </td>
    <td colspan="5" v-if="details">
      <table>
        <tr>
          <td><strong>First Name:</strong></td>
          <td>{{ audience.firstName }}</td>
          <td><strong>Last Name:</strong></td>
          <td>{{ audience.lastName }}</td>
        </tr>
        <tr>
          <td><strong>Email:</strong></td>
          <td>{{ audience.email }}</td>
          <td><strong>Order ID:</strong></td>
          <td>{{ audience.orderId }}</td>
        </tr>
        <tr>
          <td><strong>Tier:</strong></td>
          <td>{{ audience.tierName }}</td>
        </tr>
        <tr>
          <td><strong>Price:</strong></td>
          <td>${{ audience.price }}</td>
          <td><strong>Quantity:</strong></td>
          <td>{{ audience.quantity }}</td>
        </tr>
        <tr>
          <td><strong>Discount Code/Note:</strong></td>
          <td colspan="3">{{ audience.discountCode }}</td>
        </tr>
      </table>
    </td>
    <td
      v-if="!details"
      class="is-hidden-mobile"
      :class="{ deleting: deleting }"
    >
      {{ audience.email }}
    </td>
    <td v-if="!details" :class="{ deleting: deleting }">
      {{ remaining }}
    </td>
    <td
      v-if="!deleting && !details"
      :class="{ deleting: deleting }"
      class="is-hidden-mobile"
    >
      {{ audience.tierName }}
    </td>
    <td v-if="deleting" class="canceling">
      Cancelled
    </td>
    <td v-if="deleting" @click.stop>
      <button class="button" @click="undoCancel()" v-if="!deleted">Undo</button>
    </td>
    <td v-if="!deleting" @click.stop>
      <div class="select">
        <select v-model.number="checkqty" class="checkin">
          <option value="1">1</option>
          <option v-if="remaining >= 2" value="2">2</option>
          <option v-if="remaining >= 3" value="3">3</option>
          <option v-if="remaining >= 4" value="4">4</option>
          <option v-if="remaining >= 5" value="5">5</option>
          <option v-if="remaining >= 6" value="6">6</option>
          <option v-if="remaining >= 7" value="7">7</option>
          <option v-if="remaining >= 8" value="8">8</option>
        </select>
      </div>
      <button class="button checkin is-hidden-mobile" @click="checkin">
        Check In
      </button>
      <button class="button checkin checkinmob is-mobile" @click="checkin">
        <span class="icon is-large"> <i class="fas fa-check"></i> </span>
      </button>
      <ItemMenu>
        <a class="dropdown-item" @click="move()">Move to another date</a>
        <a v-if="event.seasonId" class="dropdown-item" @click="moveshow()"
          >Move to another show</a
        >
        <a class="dropdown-item" @click="showCancelModal()">Cancel</a>
      </ItemMenu>
    </td>
  </tr>
</template>

<script>
import firebase from "firebase/app";
import store from "@/store";
import { mapGetters } from "vuex";
import ItemMenu from "@/components/itemMenu";
//import { event } from "firebase-functions/v1/analytics";

export default {
  props: {
    audience: Object,
    eventId: String,
    dateId: String
  },
  components: {
    ItemMenu
  },
  data() {
    return {
      checkqty: 0,
      deleting: false,
      deleted: false,
      details: false,
      timer: null,
      selectedDate: null
    };
  },
  computed: {
    ...mapGetters({
      event: "event",
      eventDates: "eventDates"
    }),
    remaining() {
      return this.audience.quantity - this.audience.checkedin;
    }
  },
  created() {
    this.checkqty = this.remaining;
  },
  methods: {
    handleRowClick() {
      this.$emit("showOrderDetails", this.audience);
    },
    async checkin() {
      //checkin
      await store.dispatch("checkin", {
        eventId: this.eventId,
        dateId: this.dateId,
        audience: this.audience,
        checkqty: this.checkqty
      });
      if (this.remaining > 0) this.checkqty = this.remaining;
    },
    showCancelModal() {
      this.$emit("show-cancel-modal", this.audience);
    },
    cancel() {
      this.deleting = true;
      this.timer = setTimeout(() => {
        if (this.deleting) {
          var db = firebase.firestore();
          db.collection("events")
            .doc(this.eventId)
            .collection("userData")
            .doc("audienceReport")
            .collection("dates")
            .doc(this.dateId)
            .collection("audience")
            .doc(this.audience.id)
            .update({ status: "cancelled" })
            .catch(function(error) {
              console.error("Error cancelling reservation: ", error);
            });
          console.log("beleted!");
          store.dispatch("cancelWillcalll", this.audience);
          this.deleted = true;
        }
      }, 5000);
    },
    async move() {
      this.$emit("move");
      console.log("Moved!");
    },
    moveshow() {
      this.$emit("moveshow");
      console.log("Moved show!");
    },
    undoCancel() {
      this.deleting = false;
      window.clearTimeout(this.timer);
    },
    setDate(date) {
      this.selectedDate = date;
    }
  }
};
</script>

<style lang="scss">
@import "@/assets/variables.scss";

button.event-menu {
  width: 40px;
  min-width: 40px;
  height: 40px;
  margin-left: 10px;
}
.deleting {
  opacity: 0.1;
  transition: opacity 5s;
}
.canceling {
  opacity: 0.4;
  transition: opacity 5s;
}
.checkinmob {
  min-width: 0;
}

.clickable-row {
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: $gray6;
  }

  &:active {
    background-color: $gray5;
  }
}

.clickable-row:hover td {
  background-color: $gray6;
}
</style>
